import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';

export default function useGetPaginatedOrders(pageIndex, pageSize, onlyReadyOrders) {
    const url = `${apiBaseURL}/api/Orders/page?ReadyToOrderOnly=${onlyReadyOrders}&pageSize=${pageSize}&page=${pageIndex + 1}`;

    const { data, error, mutate, isLoading } = useSWR(url, {
        onSuccess: (data) => console.log('Paginated orders fetched successfully:', data?.data),
        onError: (err) => console.error('Error fetching paginated orders:', err),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });

    const noResults = !isLoading && Array.isArray(data?.data) && data.data.length === 0;
    console.log('noresultspag:', noResults)

    return {
        orders: data?.data || [],
        totalCount: data?.totalCount || 0,
        error,
        mutate,
        isLoading,
        noResults,
    };
}
